import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookinginamritsar() {



  const cardData =
  {
    keyword: 'Cab Booking in Amritsar',
    heading: 'Aaryan Travels: Cab Booking in Amritsar',
    headingDescription: ' Aaryan Travels makes Cab Booking in Amritsar easy and hassle-free with 24/7 availability for local rides, airport pickups, sightseeing tours, and outstation trips. Whether you’re planning a visit to the Golden Temple, exploring Wagah Border, or traveling to nearby cities like Chandigarh, Pathankot, or Jammu, our well-maintained sedans, SUVs, and tempo travellers ensure a safe and comfortable journey. With experienced drivers, transparent fares, and doorstep pickup from any location in the city, Aaryan Travels is the trusted choice for reliable taxi booking in Amritsar. From railway station transfers to corporate travel, we deliver quick and professional cab services tailored to your needs.',

    top: 'Top Places to Visit in Amritsar with Aaryan Travels',

"topPlaces": [
  {
    "title": "Golden Temple (Harmandir Sahib)",
    "description": "The Golden Temple is the holiest shrine of Sikhism, renowned for its gold-plated sanctum sitting gracefully in the middle of a sacred lake. Devotees from around the world visit to seek peace and blessings. The divine sound of Gurbani kirtan and the serene reflections in the water create a heavenly atmosphere. The temple's Langar serves free meals to thousands daily, symbolizing equality and service. The Golden Temple is Amritsar’s radiant heart of devotion."
  },
  {
    "title": "Jallianwala Bagh",
    "description": "Jallianwala Bagh is a memorial park dedicated to the martyrs of the 1919 massacre led by British forces. Bullet marks on the walls and the preserved well stand as silent witnesses to the tragic event. The flame-shaped memorial and light-and-sound show evoke deep patriotism. The garden is a powerful reminder of India’s freedom struggle. Jallianwala Bagh is Amritsar’s ground of sacrifice and national pride."
  },
  {
    "title": "Wagah Border Ceremony",
    "description": "Located on the India-Pakistan border, the Wagah Border hosts the daily Beating Retreat Ceremony. Soldiers from both nations perform synchronized drills, energetic marches, and flag-lowering rituals. The roaring cheers of ‘Bharat Mata Ki Jai’ and patriotic music electrify the atmosphere. It is a thrilling spectacle of discipline and unity. Wagah Border is Amritsar’s patriotic power show."
  },
  {
    "title": "Akal Takht",
    "description": "Akal Takht, situated within the Golden Temple complex, is one of the five seats of Sikh authority established by Guru Hargobind Sahib. It stands as a symbol of justice and sovereignty. The structure reflects a fusion of strength and spirituality. Devotees visit to seek guidance and pay respects. Akal Takht is Amritsar’s seat of courage and leadership."
  },
  {
    "title": "Durgiana Temple",
    "description": "Durgiana Temple, also known as the Silver Temple, resembles the Golden Temple in architecture but is dedicated to Goddess Durga. Its holy pond and glowing facade attract both pilgrims and tourists. The intricate silver doors and peaceful ambiance make it spiritually uplifting. Festivals like Navratri are celebrated with grandeur. Durgiana Temple is Amritsar’s divine mirror of devotion."
  },
  {
    "title": "Hall Bazaar",
    "description": "Hall Bazaar is one of Amritsar’s oldest and busiest marketplaces, known for traditional Phulkari embroidery, juttis, spices, and handicrafts. The arched Mughal-style entrance welcomes shopaholics and food lovers alike. Colorful lanes filled with aroma of street snacks like Amritsari kulcha and lassi make the experience unforgettable. Hall Bazaar is Amritsar’s bustling shopping soul."
  },
  {
    "title": "Partition Museum",
    "description": "The Partition Museum documents the emotional and historical journey of India’s 1947 partition. Exhibits include letters, photographs, and personal belongings of refugees who migrated during the divide. Audio-visual stories offer moving insights into resilience and healing. It is an essential stop for understanding India’s past. The Partition Museum is Amritsar’s archive of memories and humanity."
  },
  {
    "title": "Gobindgarh Fort",
    "description": "Gobindgarh Fort is a historic fortress once ruled by Maharaja Ranjit Singh. Now converted into a cultural attraction, it features live folk performances, 7D shows, and traditional food courts. The light-and-sound show narrates Punjab’s valorous past. Visitors enjoy camel rides and weapon displays inside the fort. Gobindgarh Fort is Amritsar’s warrior heritage brought to life."
  },
  {
    "title": "Ram Bagh Gardens & Maharaja Ranjit Singh Museum",
    "description": "Ram Bagh Gardens is a peaceful green expanse once used as the summer palace of Maharaja Ranjit Singh. The museum inside displays royal artifacts, paintings, and weapons. Sculptures and fountains enhance the garden’s charm. It is ideal for leisurely walks and history tours. Ram Bagh is Amritsar’s elegant blend of nature and royalty."
  },
  {
    "title": "Khalsa College",
    "description": "Khalsa College is an architectural marvel built in Indo-Saracenic style, featuring red sandstone domes and arched corridors. Established in 1892, the institution has produced many national leaders and scholars. Its expansive campus and heritage design attract photographers and tourists. The college looks especially stunning at sunrise and sunset. Khalsa College is Amritsar’s pride in education and elegance."
  }
],


"services": [
  {
    "name": "Cab Booking in Amritsar",
    "description": "Easily book cabs in Amritsar with our efficient cab booking service designed for your convenience. Whether it’s a quick city ride or a long-distance trip, our platform allows you to schedule rides with instant confirmations and secure payment options. With a variety of vehicles available, you can choose the perfect cab that suits your travel needs, ensuring a hassle-free experience every time."
  },
  {
    "name": "Book Taxi Amritsar",
    "description": "Book your taxi in Amritsar effortlessly through our user-friendly system. We offer reliable, prompt, and safe taxi services across the city. Professional drivers, well-maintained vehicles, and transparent pricing make your ride comfortable and stress-free. Whether for business or leisure, our taxis are ready to get you where you need to go on time."
  },
  {
    "name": "Online Cab Amritsar",
    "description": "Enjoy the ease of online cab booking in Amritsar with our quick and secure platform. With just a few clicks, you can schedule rides, track your driver in real-time, and make cashless payments. This service is perfect for busy individuals who prefer to plan their travels in advance without any hassle or waiting times."
  },
  {
    "name": "Amritsar Sedan Taxi",
    "description": "Travel in style and comfort with our Amritsar Sedan Taxi service. Our fleet of clean, air-conditioned sedans is perfect for business trips, airport transfers, and city travel. Drivers are courteous, professional, and knowledgeable about the best routes, ensuring a smooth, punctual journey every time."
  },
  {
    "name": "SUV Cab Amritsar",
    "description": "For larger groups or those needing extra luggage space, our SUV Cab service in Amritsar offers spacious and comfortable rides. Whether for family outings, group travel, or long-distance trips, our SUVs provide premium comfort, safety features, and reliable performance for a superior travel experience."
  },
  {
    "name": "Local Taxi Booking Amritsar",
    "description": "Our local taxi booking service in Amritsar caters to your daily commuting needs within the city. Quick pickups, affordable fares, and knowledgeable drivers ensure you reach your destination on time. Ideal for office commutes, shopping trips, or visiting friends and family with utmost convenience."
  },
  {
    "name": "Best Cab Amritsar",
    "description": "Experience the best cab services in Amritsar, where quality meets affordability. Our top-rated taxis combine professional drivers, clean vehicles, and excellent customer support to deliver rides that are safe, reliable, and comfortable. Perfect for all types of travel, including airport transfers, corporate rides, and personal errands."
  },
  {
    "name": "Trusted Taxi Amritsar",
    "description": "Our trusted taxi service in Amritsar is committed to providing safe, reliable, and professional transportation. With thorough driver background checks and regular vehicle maintenance, you can trust us for your everyday travel needs or special occasions. Customer satisfaction and safety are our top priorities."
  },
  {
    "name": "24x7 Cab Booking Amritsar",
    "description": "Travel anytime with our 24x7 cab booking service in Amritsar. Whether it’s early morning airport pickups or late-night returns, we ensure round-the-clock availability. Our fleet is always ready with professional drivers and clean vehicles, giving you peace of mind no matter the hour."
  },
  {
    "name": "Outstation Taxi Amritsar",
    "description": "Plan your outstation trips with our reliable outstation taxi service from Amritsar. Ideal for travel to nearby cities and tourist destinations, our taxis offer comfortable rides with experienced drivers who ensure a safe and pleasant journey. Choose from flexible packages including one-way and round-trip options tailored to your itinerary."
  },
  {
    "name": "Affordable Cab Amritsar",
    "description": "Our affordable cab service in Amritsar provides budget-friendly options without compromising quality or safety. Perfect for daily commuters, students, and travelers looking for economical rides, we offer transparent pricing, timely pickups, and a comfortable travel experience throughout the city and beyond."
  },
  {
    "name": "Amritsar Chauffeur Service",
    "description": "Opt for our professional chauffeur service in Amritsar to experience premium, chauffeur-driven rides for business or special occasions. Our well-trained drivers ensure courteous, safe, and discreet service, allowing you to focus on your work or enjoy your event without worrying about driving or navigation."
  },
  {
    "name": "Fast Taxi Amritsar",
    "description": "Need a quick ride? Our fast taxi service in Amritsar guarantees prompt pickups and timely drop-offs. With an extensive network of drivers, you can expect minimal waiting time and swift transit, whether it’s for emergencies, meetings, or urgent errands across the city."
  },
  {
    "name": "Airport Pickup Cab Amritsar",
    "description": "Get stress-free airport transfers with our dedicated airport pickup cab service in Amritsar. Our drivers monitor your flight timings for punctual pickups, assist with luggage, and offer comfortable rides to and from the airport. Start or end your journey with reliable and comfortable transport tailored to your schedule."
  },
  {
    "name": "City Taxi Amritsar",
    "description": "Our city taxi service in Amritsar offers convenient and affordable travel within the city limits. Whether you need transportation for office commutes, shopping, or social visits, our clean vehicles and professional drivers make every trip safe, timely, and pleasant. Flexible booking options and 24/7 availability ensure you’re always covered."
  }
],
"tableData": [
  ["Cab Booking in Amritsar", "Book Taxi Amritsar"],
  ["Online Cab Amritsar", "Amritsar Sedan Taxi"],
  ["SUV Cab Amritsar", "Local Taxi Booking Amritsar"],
  ["Best Cab Amritsar", "Trusted Taxi Amritsar"],
  ["24x7 Cab Booking Amritsar", "Outstation Taxi Amritsar"],
  ["Affordable Cab Amritsar", "Amritsar Chauffeur Service"],
  ["Fast Taxi Amritsar", "Airport Pickup Cab Amritsar"],
  ["City Taxi Amritsar", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Booking Service in Amritsar",
    "WhyChoosedescription": "Aaryan Travels offers reliable and hassle-free cab booking services throughout Amritsar for all your travel needs."
  },
  {
    "WhyChooseheading": "Fast and Convenient Pickup Anywhere in Amritsar",
    "WhyChoosedescription": "Our drivers are always nearby to ensure timely pickups and smooth rides across the city."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Every Journey",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed for your comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Well-Acquainted with Amritsar Roads",
    "WhyChoosedescription": "Our professional drivers know the city well to provide efficient and timely rides."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing including fuel, tolls, and driver allowances for a stress-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy and Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance trips as per your requirements."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group and Luggage",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your comfort and luggage needs."
  }
]





























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer cab booking services in Amritsar?',
    answer: 'Yes, Aaryan Travels provides easy and reliable cab booking services throughout Amritsar for local and outstation travel.',
  },
  {
    question: 'How can I book a cab in Amritsar with Aaryan Travels?',
    answer: 'You can book your cab quickly via our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of cabs can I book in Amritsar?',
    answer: 'Aaryan Travels offers a range of vehicles including hatchbacks, sedans, SUVs, and premium cars to meet your travel needs.',
  },
  {
    question: 'Can I book cabs for both local and outstation trips from Amritsar?',
    answer: 'Yes, you can book cabs for local city rides as well as outstation journeys from Amritsar with Aaryan Travels.',
  },
  {
    question: 'Are the drivers experienced and knowledgeable about Amritsar routes?',
    answer: 'Absolutely. Our drivers are trained, licensed, and familiar with Amritsar and nearby areas to ensure safe and smooth travel.',
  },
  {
    question: 'Is 24x7 cab booking service available in Amritsar?',
    answer: 'Yes, Aaryan Travels offers round-the-clock cab booking services for your convenience in Amritsar.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cabs in Amritsar?',
    answer: 'All vehicles are regularly sanitized and our drivers adhere to strict safety protocols to protect passengers.',
  },
  {
    question: 'What payment methods are accepted for cab bookings in Amritsar?',
    answer: 'We accept cash, credit/debit cards, UPI, and major digital wallets for seamless transactions.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations in Amritsar?',
    answer: 'Yes, Aaryan Travels allows full customization of your pickup and drop locations within Amritsar.',
  },
  {
    question: 'Is there an option for hourly cab bookings in Amritsar?',
    answer: 'Yes, we offer flexible hourly rental packages for cab bookings in Amritsar.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Malhotra',
    feedback: 'Booking a cab in Amritsar with Aaryan Travels was seamless and hassle-free. The driver was punctual and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Singh',
    feedback: 'Excellent cab booking experience in Amritsar. The vehicle was clean, and the service was very professional.',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Booking in Amritsar",
  "image": "https://aaryantravels.com/assets/images/cab-booking-amritsar.jpg", // replace with actual image URL
  "description": "Book reliable and affordable cab services in Amritsar with Aaryan Travels. Offering local, outstation, sedan, SUV, and airport pickup taxis available 24x7 with trusted drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",  // example rating, update if needed
    "ratingCount": "1400", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "900",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/cab-booking-amritsar"
  }
};






  return (
    <div>
<Helmet>
  <title>Cab Booking in Amritsar | Affordable & Trusted Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Book reliable and affordable cab services in Amritsar with Aaryan Travels. Offering local, outstation, sedan, SUV, and airport pickup taxis available 24x7 with trusted drivers."
  />
  <meta
    name="keywords"
    content="Cab Booking in Amritsar, Book Taxi Amritsar, Online Cab Amritsar, Amritsar Sedan Taxi, SUV Cab Amritsar, Local Taxi Booking Amritsar, Best Cab Amritsar, Trusted Taxi Amritsar, 24x7 Cab Booking Amritsar, Outstation Taxi Amritsar, Affordable Cab Amritsar, Amritsar Chauffeur Service, Fast Taxi Amritsar, Airport Pickup Cab Amritsar, City Taxi Amritsar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabbookinginamritsar;